
  // Bookmark and like toggles. Optimistic, and roll back if the write fails — same
  // contract as the dashboard's bookmark and heart (assets/features/space-card.ts). The two differ
  // only in names, so one wiring serves both from a small table.
  (function(){
    var V=JSON.parse((document.currentScript&&document.currentScript.getAttribute("data-v"))||"{}"),spaceId=V.id;
    if(!window.heartBurst){
    document.addEventListener("click",function(e){
      var b=e.target&&e.target.closest?e.target.closest(".like-btn,.heart-btn"):null;
      var svg=b&&b.querySelector("svg");
      if(svg)b._burstRect=svg.getBoundingClientRect();
    },true);
    window.heartBurst=function(btn){
      var svg=btn&&btn.querySelector("svg");if(!svg)return;
      var r=btn._burstRect||svg.getBoundingClientRect();btn._burstRect=null;
      if(!r.width)return;
      var el=document.createElement("span");el.className="heart-burst";el.setAttribute("aria-hidden","true");
      var c=svg.cloneNode(true);c.setAttribute("fill","currentColor");c.setAttribute("stroke","none");
      c.setAttribute("width",r.width);c.setAttribute("height",r.height);
      el.appendChild(c);el.style.left=r.left+"px";el.style.top=r.top+"px";
      // The full flight is 120px plus half of a 5x heart; with less room than that
      // above, float down instead so the whole arc stays on screen.
      if(r.top<120+r.height*2.5)el.style.setProperty("--dir","1");
      el.addEventListener("animationend",function(){el.remove()});
      document.body.appendChild(el);
    };
  }
    var SS_TIPF_HOVERS=!!(window.matchMedia&&window.matchMedia("(hover: hover) and (pointer: fine)").matches);
    var SS_TIPF_STYLE="position:fixed;z-index:2147483647;pointer-events:none;width:max-content;"+
      "max-width:min(240px,60vw);font:400 12px/1.35 var(--ss-font-sans,system-ui);background:var(--ss-surface);color:var(--ss-text);border:1px solid var(--ss-border);border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,.1);padding:4px 8px;text-align:center;white-space:normal;";
    function ssTipFixed(el,text,o){
      if(!el)return;
      var t=String(text==null?"":text).trim();
      var aria=(o&&o.as)==="label"?"aria-label":"aria-description";
      if(!t){el.removeAttribute(aria);return}
      el.setAttribute(aria,t);
      var card=null,wait=null;
      function update(value){
        t=String(value==null?"":value).trim();
        el.setAttribute(aria,t);
        if(card)card.textContent=t;
      }
      if(!SS_TIPF_HOVERS&&!(o&&o.tap))return update;
      function hide(){
        if(wait){clearTimeout(wait);wait=null}
        if(card){card.remove();card=null;window.removeEventListener("scroll",hide,true)}
      }
      function show(){
        wait=null;
        if(card)return;
        card=document.createElement("span");
        card.setAttribute("data-ss-ui","1");
        card.style.cssText=SS_TIPF_STYLE;
        if(o&&o.maxWidth)card.style.maxWidth="min("+o.maxWidth+"px,60vw)";
        card.textContent=t;
        document.body.appendChild(card);
        // Measured after it is in the document, then kept inside the viewport —
        // the trigger can sit hard against an edge, which is the whole reason a
        // centred card was being cut off in the first place.
        var r=el.getBoundingClientRect(),w=card.offsetWidth,vw=document.documentElement.clientWidth;
        var up=o&&o.at==="above"&&r.top-4-card.offsetHeight>=8;
        card.style.top=(up?r.top-4-card.offsetHeight:r.bottom+4)+"px";
        card.style.left=Math.max(8,Math.min(Math.round(r.left+r.width/2-w/2),vw-8-w))+"px";
        // Capture, so a scroll in ANY container dismisses it and not just the page.
        window.addEventListener("scroll",hide,true);
      }
      if(SS_TIPF_HOVERS){
        el.addEventListener("mouseenter",function(){clearTimeout(wait);wait=setTimeout(show,1500)});
        el.addEventListener("mouseleave",hide);
      }
      // Tabbing to something is asking for it: no wait, matching the stylesheet.
      el.addEventListener("focus",show);
      el.addEventListener("blur",hide);
      return update;
    }
    var bookmarkAliases=V.aliases;
    function wire(btnId,k,initial){
      var btn=document.getElementById(btnId);
      if(!btn)return;
      var count=initial;
      // Both ride the viewport card, not [data-tip]: .rate-wrap clips its buttons.
      var setTip=ssTipFixed(btn,k.add,{maxWidth:160}),bookmark=k.path==="favorite";
      function paint(on,n){
        // The tally follows your own click until the server sends the real total.
        if(typeof n==="number")count=n;
        else if(on!==btn.classList.contains("on"))count=Math.max(0,count+(on?1:-1));
        var nel=btn.querySelector(k.cell);
        if(nel)nel.textContent=count>0?String(count):"";
        btn.classList.toggle("on",on);
        btn.setAttribute("aria-pressed",on?"true":"false");
        var label=on?k.remove:k.add;
        var full=count>0?label+" · "+count+" "+k.noun:label;
        btn.setAttribute("aria-label",full);
        if(bookmark){
          var shown=bookmarkAliases.slice(0,5).map(function(alias){return "@"+alias});
          var rest=Math.max(0,count-shown.length);
          var who=shown.join(", ")+(rest>0?" (+"+rest+")":"");
          setTip(shown.length?"Bookmarked by "+who:full);
        }else if(setTip)setTip(full);
        // The row says what it does in words now, so the wording has to track the state.
        var lbl=btn.querySelector(".mi-label");
        if(lbl)lbl.textContent=label;
        var svg=btn.querySelector("svg");
        if(svg){svg.setAttribute("fill",on?"currentColor":"none");svg.setAttribute("stroke",on?"none":"currentColor")}
      }
      paint(btn.classList.contains("on"),initial);
      btn.onclick=function(){
        if(btn.disabled)return;
        var on=!btn.classList.contains("on");
        paint(on);btn.disabled=true;
        // The firework fires on the like itself, not on unlike or on a rollback.
        if(on&&k.path==="like")window.heartBurst(btn);
        var body={};body[k.field]=on;
        fetch("/api/space/"+spaceId+"/"+k.path,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
          .then(function(r){return r.ok?r.json():Promise.reject(r.status)})
          .then(function(d){if(k.path==="favorite"&&Array.isArray(d.aliases))bookmarkAliases=d.aliases;paint(!!d[k.field],typeof d.count==="number"?d.count:undefined);if(window.mixpanel)mixpanel.track(d[k.field]?k.track[0]:k.track[1],{space_id:spaceId,surface:"viewer"})})
          .catch(function(){paint(!on)})
          .then(function(){btn.disabled=false});
      };
    }
    wire("favBtn",{cell:".fav-n",path:"favorite",field:"favorited",add:"Add bookmark",remove:"Remove bookmark",noun:"bookmarks",track:["Space Favorited","Space Unfavorited"]},V.favN);
    wire("likeBtn",{cell:".like-n",path:"like",field:"liked",add:"Like",remove:"Unlike",noun:"likes",track:["Space Liked","Space Unliked"]},V.likeN);
  })();
